import * as actionTypes from './actionTypes'

// Libraries
import { handleActions } from 'redux-actions'

/**
 * Logs state is a mapping between every Logger type (and the default type)
 *    and its set log level.
 * eg. {
 *    DEFAULT: 'DEBUG',
 *    AUTH: 'DEBUG',
 *    CALL: 'INFO',
 *    ...
 * }
 */

const reducers = {}

reducers[actionTypes.LEVELS_CHANGE] = {
  next (state, action) {
    // Replace all levels that have been changed.
    return {
      ...state,
      ...action.payload
    }
  }
}

const reducer = handleActions(reducers, {})
export default reducer
